/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import FontAwesome from 'react-fontawesome';

import { _ab, getColor, _ab_color } from '../../style';
import { DISABLED_STATE } from '../../style/colors';

const _buttonColor = props => {
  if (!props) return _ab.blue;
  return (
    (props && getColor(props.buttonColor)) || (props.buttonDisabled ? DISABLED_STATE : _ab.blue)
  );
};
const _buttonHoverColor = props => {
  if (!props) return _ab.hoverBlue;
  return (
    (props && getColor(props.buttonHover)) ||
    (props.buttonDisabled ? DISABLED_STATE : _ab.hoverBlue)
  );
};

const _SimpleButtonButton = styled('button')`
  align-items: center;
  background: ${props => _buttonColor(props)};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '20px')};
  border: ${props => (props.border ? props.border : '1px solid transparent')};
  color: ${props => (props && props.fontColor) || 'white'};
  cursor: ${props => (props.buttonDisabled ? 'not-allowed' : 'pointer')};
  display: flex;
  font-size: 1em;
  height: ${props => (props && props.buttonHeight) || '100%'};
  justify-content: center;
  min-height: ${props => props.buttonMinHeight || 0};
  margin-left: ${props => (props && props.marginLeft) || '0px'};
  outline: ${({ animated }) => (animated ? 'none' : null)};
  overflow: hidden;
  pointer-events: ${props => (props.buttonDisabled ? 'none' : 'all')};
  position: relative;
  text-align: center;
  vertical-align: middle;
  white-space: normal;
  width: ${props => (props && props.buttonWidth) || '100%'};
  word-break: break-word;
  &.nowrap {
    white-space: nowrap;
  }
  &.disabled {
    background-color: ${({ animated }) => (animated ? null : DISABLED_STATE)};
    cursor: not-allowed;
    &:hover {
      background: ${DISABLED_STATE} !important;
    }
  }
  ${props => {
    if (props.animated) {
      return `
        .normal {
          ${_animatedChildren};
          opacity: ${props.state == 'normal' ? '1' : '0'};
          transition-delay: ${props.state == 'normal' ? '0.1s' : '0s'};
        }
        .onload {
          ${_animatedChildren};
          opacity: ${props.state == 'onload' ? '1' : '0'};
          transition-delay: ${props.state == 'onload' ? '0.1s' : '0s'};
        }
      `;
    }
  }}
  ${props => {
    if (props.secondary) {
      return `
        outline: none;
        background-color: ${_ab_color.backgroundGrey} !important;
        color: inherit;
        &:hover {
          background-color: ${
            props.disabled ? `${DISABLED_STATE} !important` : `${_ab_color.lightGrey} !important`
          };
        }
      `;
    }
  }}
  &:hover {
    background: ${props => _buttonHoverColor(props)};
  }
`;

const _animatedChildren = `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.4s;
`;

const _FontAwesome = styled.div`
  align-items: center;
  background: ${props => _buttonHoverColor(props)};
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 40px;
`;

class SimpleButton extends React.Component {
  render() {
    const {
      children,
      disabled,
      className,
      onClick,
      onKeyDown,
      fontAwesome,
      ariaLabelText,
      ...rest
    } = this.props;

    const buttonClassName = [className, disabled ? 'disabled' : null].filter(e => !!e).join(' ');

    return (
      <_SimpleButtonButton
        {...rest}
        className={buttonClassName}
        onClick={disabled ? undefined : onClick}
        onKeyDown={onKeyDown}
        aria-label={ariaLabelText}
        disabled={disabled}
      >
        {fontAwesome && (
          <_FontAwesome {...rest}>
            <FontAwesome name={fontAwesome} />
          </_FontAwesome>
        )}
        {children}
      </_SimpleButtonButton>
    );
  }
}

SimpleButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

SimpleButton.defaultProps = {
  className: undefined,
  disabled: false,
};

export const SimpleButtonRed = originalProps => {
  const props = {
    ...originalProps,
    buttonColor: 'red',
    buttonHover: 'hoverRed',
    className: 'nowrap',
  };

  return React.createElement(SimpleButton, props);
};

export const SimpleButtonBlue = originalProps => {
  const props = {
    ...originalProps,
    buttonColor: 'blue',
    buttonHover: 'hoverBlue',
    className: 'nowrap',
  };

  return React.createElement(SimpleButton, props);
};

export const SimpleButtonGrey = originalProps => {
  const props = {
    ...originalProps,
    buttonColor: 'grey',
    buttonHover: 'hoverGrey',
    className: 'nowrap',
  };

  return React.createElement(SimpleButton, props);
};

export default SimpleButton;
